import { useEffect, useRef } from "react";

// The newest Undo on screen, so Ctrl+Z (⌘Z on a Mac) presses it from any
// page: an Undo in a message that has gone, or that the keyboard can't
// reach, stays one key away for a minute (CMS review round 2, georges-09).
const KEEP_MS = 60 * 1000;
let last = null;

/** Remember `run` as the newest Undo; returns a function that forgets it. */
export function rememberUndo(run, label = "") {
  const entry = { run, label, at: Date.now() };
  last = entry;
  return () => {
    if (last === entry) last = null;
  };
}

/** The newest Undo still in time, taken (so a second Ctrl+Z does nothing), or null. */
export function takeUndo(now = Date.now()) {
  if (!last || now - last.at > KEEP_MS) return null;
  const entry = last;
  last = null;
  return entry;
}

/** In an Undo message: Ctrl+Z presses this message's Undo while it is the newest. */
export function useUndoKey(run) {
  const latest = useRef(run);
  latest.current = run;
  useEffect(() => rememberUndo(() => latest.current?.()), []);
}
